import { BaseError } from '@dynamic-labs-sdk/client';

import { SATOSHIS_PER_BTC } from '../waas/constants';

type InsufficientFundsErrorParams = {
  availableSatoshis: number;
  requiredSatoshis: number;
};

export class InsufficientFundsError extends BaseError {
  public readonly availableSatoshis: number;

  public readonly requiredSatoshis: number;

  constructor({ availableSatoshis, requiredSatoshis }: InsufficientFundsErrorParams) {
    const availableBtc = availableSatoshis / SATOSHIS_PER_BTC;
    const requiredBtc = requiredSatoshis / SATOSHIS_PER_BTC;

    super({
      cause: null,
      code: 'insufficient_funds_error',
      details: `Available: ${availableBtc} BTC (${availableSatoshis} satoshis), Required: ${requiredBtc} BTC (${requiredSatoshis} satoshis)`,
      docsUrl: null,
      name: 'InsufficientFundsError',
      shortMessage: 'Insufficient funds for transaction',
    });

    this.availableSatoshis = availableSatoshis;

    this.requiredSatoshis = requiredSatoshis;
  }
}
